import { useCallback, useState } from 'react';

/**
 * @deprecated Use `useTabsV2` from `hooks/useTabsV2` instead.
 * `useTabsV2` supports URL sync and tab validation via the `tabs` array.
 */
export const useTabs = (defaultValues?: string | number) => {
  const [currentTab, setCurrentTab] = useState(defaultValues || '');

  const onChangeTab = useCallback(
    (event: React.SyntheticEvent<Element, Event>, newValue: string) => {
      setCurrentTab(newValue);
    },
    []
  );

  return {
    currentTab,
    onChangeTab,
    setCurrentTab,
  };
};
